module.exports = __webpack_public_path__ + "img/img6.12ead50d.png";